import Image from 'gatsby-image';
import React from 'react';

import styles from './workpieces.module.scss';

import translations from './translations.yml';

class Workpieces extends React.Component {
  constructor(props) {
    super(props);

    this.state = { index: null };
  }

  handleKeydown = (event) => {
    if(this.state.index !== null) {
      event.preventDefault();

      const index = this.state.index
      const key = event.key;
      if(key === 'Escape') {
        this.setState({ index: null });
      } else if(key === 'ArrowLeft' && index > 0) {
        this.setState({ index: index - 1 });
      } else if(key === 'ArrowRight' && index + 1 < this.props.images.length) {
        this.setState({ index: index + 1 });
      }
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  getLabel(node) {
    if(!node.name) { return null; }

    const trimmed = node.name.replace(/\d/g, '').trim();
    return this.props.lang === 'de' ? trimmed : translations[trimmed];
  }

  render() {
    let viewer = null;
    if(this.state.index !== null) {
      const node = this.props.images[this.state.index];
      const aspectRatio = node.fullsize.sizes.aspectRatio;

      viewer =
        <div className={styles.viewer}
             onClick={() => this.setState({ index: null })}>
          <style dangerouslySetInnerHTML={{__html: `
            .fittedWidth { width: calc((100vh - 4em) * ${aspectRatio}); }
            @media (max-aspect-ratio: ${Math.floor(aspectRatio*1000)}/1000) {
              .fittedWidth { width: calc(100vw - 4em); }
            }
          `}} />

          <div className={`fittedWidth ${styles.viewerImageWrapper}`}>
            <Image sizes={node.fullsize.sizes} />

            <div className={styles.label}>
                {this.getLabel(node)}
            </div>
          </div>
        </div>
      ;
    }

    return(
      <div>
        <div className={styles.thumbnails}>
          {this.props.images.map((node, index) =>
            <div className={styles.thumbnailWrapper}
                 key={index}
                 onClick={() => this.setState({ index: index })}>
              <Image alt={this.getLabel(node)}
                     outerWrapperClassName={styles.thumbnail}
                     sizes={node.thumbnail.sizes}
                     title={this.getLabel(node)} />
            </div>
          )}
        </div>

        {viewer}
      </div>
    );
  }
}

export default Workpieces;

export const fragment = graphql`
  fragment WorkpiecesFields on File {
    name
    thumbnail: childImageSharp {
      sizes(
        duotone: {
          highlight: "#ffffff"
          shadow: "#111111"
          opacity: 50
        }
        maxHeight: 200
        maxWidth: 200
      ) {
        ...GatsbyImageSharpSizes
      }
    }
    fullsize: childImageSharp {
      sizes(maxWidth: 2560) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/workpieces/workpieces.js